import script from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCenter.vue?vue&type=style&index=0&id=769a6cb8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-769a6cb8"]])

export default __exports__